import Vue from 'vue';
import Router from 'vue-router';
import ManageAudiences from './views/ManageAudiences.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'ManageAudiences',
            component: ManageAudiences,
        },
        {
            path: '/audience/create',
            name: 'audience-create',
            component: () => import(/* WebpackChunkName: "audience-create" */ './views/CreateAudience.vue'),
            props: true
        },
        {
            path: '/audience/:audienceId/clone/:detailVersion',
            name: 'audience-clone',
            component: () => import(/* WebpackChunkName: "audience-clone" */ './views/CloneAudience.vue'),
            props: true
        },
        {
            path: '/audience/:audienceId/detail/:detailType',
            name: 'audience-details',
            component: () => import(/* WebpackChunkName: "audience-details" */ './views/AudienceDetail.vue'),
            props: true
        },
        {
            path: '/audience/:audienceId/edit/:detailId',
            name: 'audience-edit',
            component: () => import(/* WebpackChunkName: "audience-edit" */ './views/EditAudience.vue'),
            props: true
        },
        /* --- TEST AREA -- */
        {
            path: '/test',
            name: 'test',
            component: () => import(/* WebpackChunkName: "test" */ './views/Test.vue')
        }
    ],
});
